import { IonText } from "@ionic/react";
import { useSelector } from "react-redux";
import { selectDocumentCount } from "../../../store/supervisorRequiredDocuments/selectors/selectDocumentCount";
import { selectStatusFilter } from "../../../store/supervisorRequiredDocuments/selectors/selectStatusFilter";

export const DocumentCount = () => {
  const count = useSelector(selectDocumentCount);
  const statusFilter = useSelector(selectStatusFilter);
  return (
    <IonText color="primary" style={{ fontWeight: 500 }}>
      {count}{" "}
      {statusFilter?.length === 0
        ? "Pendiente, Completo, Pendiente Firma Digital"
        : statusFilter?.map(
            (statusItem, index) =>
              statusItem.name + (statusFilter?.length === index + 1 ? "" : ", ")
          )}
    </IonText>
  );
};
